export const ACCOUNT_NOT_FOUND_MSG = 'Account information not available, Please contact support.';
export const GA_MEASUREMENT_ID = "G-N0343K7EBT"

/** Day/month tokens allow optional leading zero (e.g. 5/8/26 and 05/08/26). */
const DAY = "(0?[1-9]|[12]\\d|3[01])";
const MONTH = "(0?[1-9]|1[0-2])";
const YEAR4 = "\\d{4}";
const YEAR2 = "\\d{2}";
const MON = "(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)";

export const dateFormats = [
  {
    label: "YYYY-MM-DD",
    format: "YYYY-MM-DD",
    regex: new RegExp(`^${YEAR4}-${MONTH}-${DAY}$`),
  },
  {
    label: "DD-MM-YYYY",
    format: "DD-MM-YYYY",
    regex: new RegExp(`^${DAY}-${MONTH}-${YEAR4}$`),
  },
  {
    label: "DD-MM-YY",
    format: "DD-MM-YY",
    regex: new RegExp(`^${DAY}-${MONTH}-${YEAR2}$`),
  },
  {
    label: "MM-DD-YYYY",
    format: "MM-DD-YYYY",
    regex: new RegExp(`^${MONTH}-${DAY}-${YEAR4}$`),
  },
  {
    label: "MM-DD-YY",
    format: "MM-DD-YY",
    regex: new RegExp(`^${MONTH}-${DAY}-${YEAR2}$`),
  },
  {
    label: "YYYY/MM/DD",
    format: "YYYY/MM/DD",
    regex: new RegExp(`^${YEAR4}/${MONTH}/${DAY}$`),
  },
  {
    label: "DD/MM/YYYY",
    format: "DD/MM/YYYY",
    regex: new RegExp(`^${DAY}/${MONTH}/${YEAR4}$`),
  },
  {
    label: "DD/MM/YY",
    format: "DD/MM/YY",
    regex: new RegExp(`^${DAY}/${MONTH}/${YEAR2}$`),
  },
  {
    label: "MM/DD/YYYY",
    format: "MM/DD/YYYY",
    regex: new RegExp(`^${MONTH}/${DAY}/${YEAR4}$`),
  },
  {
    label: "MM/DD/YY",
    format: "MM/DD/YY",
    regex: new RegExp(`^${MONTH}/${DAY}/${YEAR2}$`),
  },
  {
    label: "DD Mon YYYY",
    // Moment token for abbreviated month is MMM (not "Mon")
    format: "DD MMM YYYY",
    regex: new RegExp(`^${DAY} ${MON} ${YEAR4}$`, "i"),
  },
  {
    label: "Mon DD, YYYY",
    format: "MMM DD, YYYY",
    regex: new RegExp(`^${MON} ${DAY}, ${YEAR4}$`, "i"),
  },
  {
    label: "YYYY.MM.DD",
    format: "YYYY.MM.DD",
    regex: new RegExp(`^${YEAR4}\\.${MONTH}\\.${DAY}$`),
  },
];

/** Moment formats tried when auto-detecting (DD/MM before MM/DD to prefer day-first). */
export const dateParseFormats = [
  "YYYY-MM-DD",
  "YYYY/MM/DD",
  "YYYY.MM.DD",
  "DD-MM-YYYY",
  "DD-MM-YY",
  "D-M-YYYY",
  "D-M-YY",
  "DD/MM/YYYY",
  "DD/MM/YY",
  "D/M/YYYY",
  "D/M/YY",
  "DD MMM YYYY",
  "D MMM YYYY",
  "MMM DD, YYYY",
  "MMM D, YYYY",
  "MM-DD-YYYY",
  "MM-DD-YY",
  "M-D-YYYY",
  "M-D-YY",
  "MM/DD/YYYY",
  "MM/DD/YY",
  "M/D/YYYY",
  "M/D/YY",
];


export const allowedTags = [
  "b", "i", "u", "strong", "em", "br",
  "ul", "ol", "li",
  "h1", "h2", "h3", "h4", "h5", "h6",
  "p", "a"
];

export const allowedAttr = [
  'href', 'rel', 'target'
]

export const gigTypes = [
        {
            "id": 5,
            "gig_category_id": 5,
            "name": "Brand Promotion",
            "slug": "brand_promotion",
            "created_at": "2025-03-12T11:34:07.088818Z",
            "updated_at": "2025-03-12T11:34:07.088818Z",
            "flag": true,
            "object_name": "Brand",
            "class": "BrandPromotion",
            "has_value": false,
            "has_gigs": false,
            "has_options": false,
            "properties": [
                {
                    "id": 19,
                    "gig_type_id": 5,
                    "label": "URL",
                    "key": "url",
                    "type": "url",
                    "sort_order": 1,
                    "mandatory": false,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                }
            ]
        },
        {
            "id": 2,
            "gig_category_id": 2,
            "name": "Store Visit",
            "slug": "store_visit",
            "created_at": "2025-03-12T11:34:07.088818Z",
            "updated_at": "2025-03-12T11:34:07.088818Z",
            "flag": true,
            "object_name": "Store",
            "class": "StoreVisit",
            "has_value": false,
            "has_gigs": true,
            "has_options": false,
            "properties": [
                {
                    "id": 7,
                    "gig_type_id": 2,
                    "label": "Business Hours",
                    "key": "business_hours",
                    "type": "string",
                    "sort_order": 4,
                    "mandatory": false,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                },
                {
                    "id": 9,
                    "gig_type_id": 2,
                    "label": "Contact Name",
                    "key": "contact_name",
                    "type": "string",
                    "sort_order": 6,
                    "mandatory": false,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                },
                {
                    "id": 23,
                    "gig_type_id": 2,
                    "label": "Address",
                    "key": "address",
                    "type": "address",
                    "sort_order": 3,
                    "mandatory": true,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                },
                {
                    "id": 8,
                    "gig_type_id": 2,
                    "label": "Contact Number",
                    "key": "phone",
                    "type": "tel",
                    "sort_order": 5,
                    "mandatory": false,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                }
            ]
        },
        {
            "id": 3,
            "gig_category_id": 3,
            "name": "Repost",
            "slug": "repost",
            "created_at": "2025-03-12T11:34:07.088818Z",
            "updated_at": "2025-03-12T11:34:07.088818Z",
            "flag": true,
            "object_name": "Post",
            "class": "Repost",
            "has_value": false,
            "has_gigs": true,
            "has_options": false,
            "properties": [
                {
                    "id": 18,
                    "gig_type_id": 3,
                    "label": "Permalink",
                    "key": "permalink",
                    "type": "permalink",
                    "sort_order": 1,
                    "mandatory": true,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                }
            ]
        },
        {
            "id": 1,
            "gig_category_id": 1,
            "name": "Product Review",
            "slug": "product_review",
            "created_at": "2025-03-12T11:34:07.088818Z",
            "updated_at": "2025-03-12T11:34:07.088818Z",
            "flag": true,
            "object_name": "Product",
            "class": "ProductReview",
            "has_value": true,
            "has_gigs": true,
            "has_options": true,
            "properties": [
                {
                    "id": 1,
                    "gig_type_id": 1,
                    "label": "URL",
                    "key": "url",
                    "type": "url",
                    "sort_order": 1,
                    "mandatory": true,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                }
            ]
        }
    ]

  export const CREATOR_APP_URL = process.env.REACT_APP_ENV === 'production' ? 'https://app.influns.com' : 'https://app.influns.com';

  export const platforms = {
    ig: { id: 'ig', name: 'Instagram' },
    yt: { id: 'yt', name: 'YouTube' },
}

export const LOGO_CDN_URL = "https://d3esz4e2jyp077.cloudfront.net/app/logo/influns-logo.png";
export const DEFAULT_POST_COLLECTION_ID = 'all-posts';
export const DEFAULT_CREATOR_COLLECTION_ID = 'all-creators';

export const RAZORPAY_SDK = "https://checkout.razorpay.com/v1/checkout.js";

export const MSG91_CHAT_WIDGET_URL = "https://blacksea.msg91.com/chat-widget.js";
export const MSG91_WIDGET_TOKEN = "f1254";

export const WHATSAPP_SUPPORT_PHONE = '919266391960';

export const PRIMARY_COLOR = '#0069AD';
export const CREATOR_PRIMARY_COLOR = '#E11D48';